import { styled } from '@linaria/react';
import Image from 'next/image';
import RankingListHotCollection from '@fe-news/components/organisms/RankingListHotCollection';
import MyTrackDateProvider from '@fe-news/context/my-track-date-provider';

const NoNewsCollect = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 80px;
  padding-bottom: 32px;
  row-gap: 24px;
  border-bottom: dashed 2px #e2e8f1;
  margin-bottom: 32px;

  p {
    font-size: 22px;
    font-weight: 600;
    letter-spacing: 0.5px;
    color: #000;
  }
`;

type NoCollectListProps = {
  children: React.ReactNode;
};

const NoCollectList = ({ children }: NoCollectListProps) => {
  return (
    <MyTrackDateProvider>
      <NoNewsCollect>
        <Image src='/assets/icons/img-collection-nodata.svg' alt='no news collect' width={175} height={150} />
        <p>您尚未有收藏新聞</p>
      </NoNewsCollect>
      <RankingListHotCollection>{children}</RankingListHotCollection>
    </MyTrackDateProvider>
  );
};

export default NoCollectList;
